import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import OTPInput from "react-otp-input";
import { Modal, Spinner } from "react-bootstrap";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Col,
  Tab,
  Row,
} from "react-bootstrap";
import { loginKoordinator } from "stores/authKoordinator/function";
import {
  loginKoordinatorProduktif,
  requestOtp,
  sendOtp,
} from "stores/authKoordinatorProduktif/function";
import Swal from "sweetalert2";
import moment from "moment";
import loginBackground from "assets/img/full-screen-image-3.jpg";
import pageImage from "assets/img/full-screen-image-2.jpg";

function LoginPageClient() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [id, setId] = React.useState("");
  const [password, setPassword] = React.useState("");

  const [loginDisabled, setLoginDisabled] = React.useState(true);
  const [selectBox, setSelectBox] = React.useState(null);
  const [otp, setOtp] = React.useState(Array(6).fill(""));
  const [modalOtp, setModalOtp] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [messageOtp, setMessageOtp] = React.useState("");
  const [fullname, setFullname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [koordinator, setKoordinator] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [countDown, setCountDown] = React.useState(0);
  const [disabledButton, setDisabledButton] = React.useState(true);
  const [expDate, setExpDate] = React.useState("");

  const [cardClasses, setCardClasses] = React.useState("card-hidden");

  // Timer effect
  React.useEffect(() => {
    let timer;
    if (countDown > 0) {
      timer = setTimeout(() => setCountDown(countDown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countDown]);

  const kirimOtp = () => {
    requestOtp({ username: id, email: response.data.email }).then(
      (response) => {
        if (response.rc === "00") {
          setMessageOtp(response.message);
          setExpDate(moment(response.exp).format("DD MMMM YYYY HH:MM"));
        } else {
          setMessageOtp(response.message);
          setExpDate(moment(response.exp).format("DD MMMM YYYY HH:MM"));
        }
      }
    );
    setCountDown(60);
  };

  React.useEffect(() => {
    localStorage.clear();

    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  }, []);

  const inputRefs = React.useRef([]);
  React.useEffect(() => {
    setOtp(Array(6).fill(""));

    let attempt = 0;
    const maxAttempts = 10;

    const waitForInput = () => {
      const firstInput = inputRefs.current[0];

      if (firstInput && document.body.contains(firstInput)) {
        firstInput.focus();
        firstInput.setSelectionRange(
          firstInput.value.length,
          firstInput.value.length
        );
      } else if (attempt < maxAttempts) {
        attempt++;
        setTimeout(waitForInput, 30);
      }
    };

    waitForInput();
  }, [modalOtp]);

  React.useEffect(() => {
    if (otp.every((digit) => digit !== "")) {
      const kode = otp.join("");
      if (otp.length === 6) {
        setLoading(true);
        // Simulasi pengiriman OTP
        setTimeout(() => {
          setLoading(false);
          // lanjut ke proses selanjutnya
        }, 1000);
        sendOtp(
          dispatch,
          {
            username: id,
            otp: kode,
            fullname: fullname,
            email: email,
            koordinator: koordinator,
            userId: userId,
            password: password,
          },
          history
        );
      }
    }
  }, [otp]);
  const handlePrivacyLinkClick = () => {
    window.open("/privacy", "_blank", "noopener,noreferrer");
  };

  const handleCheckBox = (value) => {
    if (!value) {
      setLoginDisabled(true);
      selectBox(null);
    } else {
      setSelectBox(value);
      setLoginDisabled(false);
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();

    let confirmLogin = await Swal.fire({
      title: `Apakah anda yakin ingin login ke ${selectBox}?`,
      icon: "question",
      showDenyButton: true,
      confirmButtonText: "Ya",
      denyButtonText: "Tidak",
      allowOutsideClick: false,
    });

    if (confirmLogin.isConfirmed === true) {
      if (selectBox === "konsumtif") {
        await loginKoordinator(dispatch, { id, password }, history);
      } else {
        await loginKoordinatorProduktif(dispatch, {
          id,
          password,
        }).then((response) => {
          if (response?.success === true) {
            setModalOtp(true);
            setFullname(response.data.fullname);
            setEmail(response.data.email);
            setKoordinator(response.data.koordinator);
            setUserId(response.data.user_id);
            requestOtp({ username: id, email: response.data.email }).then(
              (response) => {
                if (response.rc === "00") {
                  setDisabledButton(false);
                  setMessageOtp(response.message);
                  setExpDate(moment(response.exp).format("DD MMMM YYYY HH:MM"));
                } else {
                  setDisabledButton(true);
                  setMessageOtp(response.message);
                  setExpDate(moment(response.exp).format("DD MMMM YYYY HH:MM"));
                }
              }
            );
          }
        });
      }
    }
  };

  const handleKirimUlangOtp = async (e) => {
    e.preventDefault();

    let confirmLogin = await Swal.fire({
      title: `Apakah anda yakin ingin mengirim ulang otp?`,
      icon: "question",
      showDenyButton: true,
      confirmButtonText: "Ya",
      denyButtonText: "Tidak",
      allowOutsideClick: false,
    });

    if (confirmLogin.isConfirmed === true) {
      kirimOtp();
    }
  };
  const handleOtpChange = (value) => {
    setOtp(value);
  };

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const next = document.getElementById(`otp-${index + 1}`);
      if (next) next.focus();
    }
  };

  const focusInput = (index) => {
    const input = document.getElementById(`otp-${index}`);
    if (input) {
      input.focus();
      // Nonaktifkan highlight atau seleksi dengan cara set selection ke posisi akhir langsung
      input.setSelectionRange(input.value.length, input.value.length);
      input.style.caretColor = "#000"; // Pastikan kursor terlihat jelas
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index] !== "") {
        // Langkah 1: kalau masih ada isinya → hapus
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Langkah 2: kalau sudah kosong → geser ke kiri
        focusInput(index - 1);
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault();
      focusInput(index - 1);
    }

    if (e.key === "ArrowRight" && index < otp.length - 1) {
      e.preventDefault();
      focusInput(index + 1);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(pasted)) return;

    const newOtp = [...otp];
    pasted
      .slice(0, otp.length)
      .split("")
      .forEach((char, i) => {
        newOtp[i] = char;
      });

    setOtp(newOtp);
  };

  const handleNumberOnly = (e) => {
    if (
      !/[0-9]/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Tab" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div
        className="full-page section-image"
        data-color="black"
        data-image={pageImage}
      >
        <div className="content d-flex align-items-center p-0">
          <Container>
            <Col className="mx-auto" lg="4" md="8">
              <Form action="" className="form" method="">
                <Card
                  className={"card-login " + cardClasses}
                  style={{ backgroundColor: "#CEE4FB" }}
                >
                  <Card.Header style={{ backgroundColor: "#CEE4FB" }}>
                    <h3
                      className="header text-center"
                      style={{ fontWeight: "bold", color: "#000000" }}
                    >
                      Login Klien
                    </h3>
                  </Card.Header>
                  <Card.Body>
                    <Card.Body>
                      <Form.Group>
                        <label style={{ color: "#000000" }}>
                          <b>Username</b>
                        </label>
                        <Form.Control
                          value={id}
                          onChange={(e) => {
                            setId(e.target.value);
                          }}
                          placeholder="Enter Username"
                          type="email"
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group>
                        <label style={{ color: "#000000" }}>
                          <b>Password</b>
                        </label>
                        <Form.Control
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                          placeholder="Password"
                          type="password"
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group>
                        <label style={{ color: "#000000" }}>
                          <b>Kategori</b>
                        </label>
                        <Row>
                          <Col>
                            <div className="d-flex align-items-center gap-2">
                              <Form.Control
                                checked={selectBox === "konsumtif"}
                                onChange={() => {
                                  handleCheckBox("konsumtif");
                                }}
                                type="radio"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  transform: "scale(0.9)",
                                  margin: 0,
                                  marginRight: 5,
                                  cursor: "pointer",
                                }}
                              />
                              <span style={{ fontWeight: "bold" }}>
                                Konsumtif
                              </span>
                            </div>
                          </Col>
                          <Col>
                            <div className="d-flex align-items-center gap-2">
                              <Form.Control
                                checked={selectBox === "produktif"}
                                onChange={() => {
                                  handleCheckBox("produktif");
                                }}
                                type="radio"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  transform: "scale(0.9)",
                                  margin: 0,
                                  marginRight: 5,
                                  cursor: "pointer",
                                }}
                              />
                              <span style={{ fontWeight: "bold" }}>
                                Produktif
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Card.Body>
                  </Card.Body>
                  <Card.Footer className="ml-auto mr-auto">
                    <Button
                      onClick={handleLogin}
                      className="btn-wd"
                      type="submit"
                      // variant="warning"
                      style={{
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        backgroundColor: "#157DEC",
                        border: 0,
                        cursor: loginDisabled ? "not-allowed" : "pointer",
                      }}
                      disabled={loginDisabled}
                    >
                      Login
                    </Button>
                  </Card.Footer>
                  <a
                    href="/auth/login-page"
                    // target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#FF003F",
                      fontSize: 16,
                      textDecoration: "none",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    Kembali ke login BAP
                  </a>
                </Card>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <a
                    href="/auth/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "white",
                      fontSize: 14,
                      textDecoration: "none",
                      marginLeft: 25,
                    }}
                  >
                    Privacy Policy
                  </a>
                  <label
                    style={{
                      marginLeft: 10,
                      marginRight: 10,
                      color: "white",
                    }}
                  >
                    |
                  </label>
                  <a
                    href="/auth/termsandconditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "white",
                      fontSize: 14,
                      textDecoration: "none",
                    }}
                  >
                    Terms & Conditions
                  </a>
                </div>
              </Form>
            </Col>
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url("${loginBackground}")`,
          }}
        ></div>
      </div>
      <Modal
        size="md"
        show={modalOtp}
        onHide={() => setModalOtp(false)}
        backdrop="static"
        // onHide={() => setModalCekStatus(!modalCekStatus)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "40px 20px",
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title
                as="h4"
                style={{ color: "black", fontWeight: "bold" }}
              >
                <h5
                  style={{
                    fontWeight: "bold",
                    marginBottom: "5px",
                    color: "#333",
                  }}
                >
                  Masukkan Kode OTP
                </h5>

                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <div style={{ minHeight: "50px", marginTop: "20px" }}>
                <OTPInput
                  value={otp} // jangan .join("")
                  numInputs={6}
                  isInputNum
                  shouldAutoFocus
                  containerStyle={{ justifyContent: "center" }}
                  inputStyle={{
                    width: "55px",
                    height: "60px",
                    margin: "0 6px",
                    fontSize: "26px",
                    borderRadius: "12px",
                    border: "2px solid #ccc",
                    backgroundColor: "#fff",
                    color: "#222",
                    textAlign: "center",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  }}
                  focusStyle={{
                    border: "2px solid #3ABEEA",
                    outline: "none",
                    boxShadow: "0 0 6px rgba(58, 190, 234, 0.6)",
                  }}
                  renderSeparator={<span style={{ width: 8 }}>-</span>}
                  renderInput={(props, index) => (
                    <input
                      {...props}
                      id={`otp-${index}`}
                      ref={(el) => (inputRefs.current[index] = el)}
                      value={otp[index]}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                      inputMode="numeric"
                      maxLength={1}
                      pattern="\d*"
                    />
                  )}
                />

                {loading && (
                  <div style={{ marginTop: "20px" }}>
                    <Spinner animation="border" variant="primary" size="sm" />
                    <span
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        color: "#555",
                      }}
                    >
                      Mengirim kode...
                    </span>
                  </div>
                )}
                {messageOtp && (
                  <div style={{ marginTop: 16 }}>
                    <p
                      style={{
                        color: "#1565c0",
                        fontSize: 14,
                        marginBottom: 4,
                      }}
                    >
                      * {messageOtp}
                    </p>
                    <p style={{ color: "#2e7d32", fontSize: 13 }}>
                      Berlaku hingga: <strong>{expDate}</strong>
                    </p>
                  </div>
                )}
              </div>
            </Card.Body>

            <Card.Footer>
              <Button
                onClick={handleKirimUlangOtp}
                className="btn-wd"
                type="submit"
                // variant="warning"
                style={{
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  backgroundColor: " #ff9800",
                  border: 0,
                  opacity: disabledButton || countDown > 0 ? 0.6 : 1,
                  cursor:
                    disabledButton || countDown > 0 ? "not-allowed" : "pointer",
                }}
                disabled={disabledButton || countDown > 0}
              >
                {countDown > 0
                  ? `Tunggu ${countDown} detik...`
                  : "Kirim ulang OTP"}
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>
    </>
  );
}

export default LoginPageClient;
